import React, {useState} from 'react';
import {Button, Flex, Image, Modal, Popover, Table, Tooltip} from "antd";
import {clrs} from "../../constants/colors";
import {Link, useNavigate} from "react-router-dom";
import IntlMessage from "../../components/IntlMessage/IntlMessage";
import useKazakhstan from "../../constants/kz/useKazakhstan";
import {useTranslation} from "react-i18next";
import proj4 from "proj4";
import back from "../../images/back@3x.png";
import {Fade} from "react-awesome-reveal";
import lines from "../../images/lines@3x.png";
import co2 from "../../images/co2@3x.png";
import factory from "../../images/factory@3x.png";
import HighchartsReact from "highcharts-react-official";
import Highcharts from "highcharts";
import MyText from "../../components/UI/Text/MyText";
import HorizontalDivider from "../../components/Divider/HorizontalDivider";
import {DoubleRightOutlined, EllipsisOutlined, EyeOutlined, LinkOutlined} from "@ant-design/icons";
import img14 from './images/14.jpeg';
import img3 from './images/3.jpg';
import img22 from './images/22.jpg';
import img26 from './images/26.jpg';
import img28 from './images/28.jpg';
import img24 from './images/24.webp';
import img23 from './images/23.JPG';
import img29 from './images/29.png';
import img15 from './images/15.jpg';
import img27 from './images/27.jpg';
import img19 from './images/19.jpg';
import img5 from './images/5.jpg';
import img10 from './images/10.jpg';
import img12 from './images/12.png';
import img4 from './images/4.jpg';
import img25 from './images/25.jpg';
import img2 from './images/2.jpg';
import img1 from './images/1.png';
import img11 from './images/11.jpeg';
import img21 from './images/21.jpg';
import img6 from './images/6.png';
import img8 from './images/8.jpg';
import img9 from './images/9.jpg';
import user_icon from './images/user_icon.png';
import classes2 from './about.module.css';
import classes from "../components/Header/header.module.css";
import {Person1} from "../components/AboutPage/Person1";
import {Person2} from "../components/AboutPage/Person2";
import {Person3} from "../components/AboutPage/Person3";
import {Person4} from "../components/AboutPage/Person4";
import {Person5} from "../components/AboutPage/Person5";
import {Person10} from "../components/AboutPage/Person10";
import {Person11} from "../components/AboutPage/Person11";
import {Person12} from "../components/AboutPage/Person12";
import {Person14} from "../components/AboutPage/Person14";
import {Person15} from "../components/AboutPage/Person15";
import {Person19} from "../components/AboutPage/Person19";
import {Person22} from "../components/AboutPage/Person22";
import {Person23} from "../components/AboutPage/Person23";
import {Person24} from "../components/AboutPage/Person24";
import {Person25} from "../components/AboutPage/Person25";
import {Person26} from "../components/AboutPage/Person26";
import {Person27} from "../components/AboutPage/Person27";
import {Person28} from "../components/AboutPage/Person28";
import {Person29} from "../components/AboutPage/Person29";
import {Header} from "../components/AboutPage/Header";
import {UserCard} from "../components/AboutPage/UserCard";


const AboutPage = () => {

    const {t} = useTranslation();

    const navigate = useNavigate();

    const [open, setOpen] = useState(false);
    const [modalTarget, setModalTarget] = useState(null);
    const [targetName, setTargetName] = useState(null);

    const columns = [
        {
            title: '',
            render: (_, record) => (
                record.targetObject != null &&
                <Tooltip title={"Детали"} >
                    <Button onClick={() => {
                        setOpen(true);
                        setTargetName(record.name);
                        setModalTarget(record.targetObject)
                    }}>
                        <EyeOutlined />
                    </Button>
                </Tooltip>

            ),
            width: '5%',
        },
        {
            title: 'ФИО',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: 'Роль в проекте',
            dataIndex: 'role',
            key: 'role',
        },
    ];
    const data = [
        { key: 1, name: 'Белощицкий Андрей Александрович', role: 'Руководитель Программы, проректор по НиИ, д.т.н.', targetObject: <Person1/>, image: img1 },
        { key: 2, name: 'Нефтисов Александр Витальевич', role: 'Ответственный исполнитель, ведущий научный сотрудник', targetObject: <Person2/>, image: img2 },
        { key: 3, name: 'Кучанський Олександр', role: 'Старший научный сотрудник', targetObject: <Person3/>, image: img3 },
        { key: 4, name: 'Андрашко Юрий Васильевич', role: 'Старший научный сотрудник', targetObject: <Person4/>, image: img4 },
        { key: 5, name: 'Токсанов Сапар Нурахметович', role: 'Старший научный сотрудник', targetObject: <Person5/>, image: img5 },

        { key: 10, name: 'Абжанова Дилара Ерлановна', role: 'Frontend-разработчик', targetObject: <Person10/>, image: img10 },
        { key: 11, name: 'Бақыткерейұлы Батырбек', role: 'Backend-разработчик', targetObject: <Person11/>, image: img11 },
        { key: 12, name: 'Шарипова Салтанат Еркиновна', role: 'Младший научный сотрудник', targetObject: <Person12/>, image: img12 },

        { key: 14, name: 'Казамбаев Ильяс Маратула', role: 'Младший научный сотрудник', targetObject: <Person14/>, image: img14 },
        { key: 15, name: 'Кириченко Лалита Николаевна', role: 'Младший научный сотрудник', targetObject: <Person15/>, image: img15 },

        { key: 19, name: 'Командиров Евгений Витальевич', role: 'Техник-программист', targetObject: <Person19/>, image: img19 },

        { key: 22, name: 'Кислов Александр Петрович', role: 'Старший научный сотрудник', targetObject: <Person22/>, image: img22 },
        { key: 23, name: 'Жалмагамбетова Ултуар Каирбулатовна', role: 'Старший научный сотрудник', targetObject: <Person23/>, image: img23 },
        { key: 24, name: 'Шимпф Алексей Андреевич', role: 'Старший научный сотрудник', targetObject: <Person24/>, image: img24 },
        { key: 25, name: 'Микряков Андрей', role: 'Младший научный сотрудник', targetObject: <Person25/>, image: img25 },
        { key: 26, name: 'Крыкбаева Марьям Сергазиновна', role: 'Младший научный сотрудник', targetObject: <Person26/>, image: img26 },
        { key: 27, name: 'Аубакирова Алия Муратовна', role: 'Младший научный сотрудник', targetObject: <Person27/>, image: img27 },
        { key: 28, name: 'Снопков Дмитрий Игоревич', role: 'Младший научный сотрудник', targetObject: <Person28/>, image: img28 },
        { key: 29, name: 'Камбарова Жулдуз Думанбековна', role: 'Менеджер проекта', targetObject: <Person29/>, image: img29 },
        { key: 21, name: 'Куспанов Ескендир Рустамович', role: 'Специалист по блокчейн-технологиям', targetObject: <Person21/>, image: img21 },
        
        { key: 6, name: 'Абай Арын Мухтарович', role: 'Специалист по финансам', targetObject: null, image: img6 },
        { key: 8, name: 'Жакиев Нурхат Куандыкович', role: 'Старший научный сотрудник', targetObject: null, image: img8 },
        { key: 9, name: 'Файзуллин Адиль Рамазанович', role: 'Младший научный сотрудник', targetObject: null, image: img9 },
        
        { key: 7, name: 'Мухатаев Айдос Агдарбекович', role: 'Старший научный сотрудник', targetObject: null, image: user_icon },
        { key: 13, name: 'Кадыргулов Бауржан Сансызбаевич', role: 'Младший научный сотрудник', targetObject: null, image: user_icon },
        { key: 16, name: 'Ордабаев Сакен Берикович', role: 'Младший научный сотрудник', targetObject: null, image: user_icon },
        { key: 17, name: 'Завезен Борис Владимирович', role: 'Метролог', targetObject: null, image: user_icon },
        { key: 18, name: 'Ремхе Иван Иванович', role: 'Инженер-программист', targetObject: null, image: user_icon },
        { key: 20, name: 'Андреа Кадамуро', role: 'Специалист по блокчейн-технологиям', targetObject: null, image: user_icon }
    ];

    return (
        <Flex style={{width: "100%", minHeight: "100vh", position: "relative", backgroundImage: `url(${back})`, backgroundPosition: "center", backgroundSize: "cover", marginBottom: 50}} vertical align={"center"} justify={"flex-start"} gap={30}>
            <Header/>
            <Modal
                title={targetName}
                open={open}
                onOk={() => {
                    setOpen(false);
                    setModalTarget(null);
                }}
                onCancel={() => {
                    setOpen(false);
                    setModalTarget(null);
                }}
                footer={[
                    <Button key="ok" type="primary" onClick={() => {
                        setOpen(false);
                        setModalTarget(null);
                    }}>
                        OK
                    </Button>
                ]}
                width={1000}
            >
                {modalTarget}
            </Modal>
            <Flex style={{width: "100%", maxWidth: "1440px", padding: 20, background: clrs.white}} gap={20} vertical>
                <Fade triggerOnce={true} cascade damping={0.15} direction={"down"}>
                    <MyText strong size={"large"}>
                        <IntlMessage id={'aboutPage.projectTitle'}/>
                    </MyText>
                    <MyText>
                        <IntlMessage id={'aboutPage.projectName'}/>
                    </MyText>
                    <HorizontalDivider/>
                    <MyText strong size={"large"}>
                        <IntlMessage id={'aboutPage.projectGoal'}/>
                    </MyText>
                    <MyText>
                        <IntlMessage id={'aboutPage.projectGoalText'}/>
                    </MyText>
                    <HorizontalDivider/>
                    <MyText strong size={"large"}>
                        <IntlMessage id={'aboutPage.programTasks'}/>
                    </MyText>
                    <MyText>
                        <IntlMessage id={'aboutPage.task1'}/>
                    </MyText>
                    <MyText>
                        <IntlMessage id={'aboutPage.task2'}/>
                    </MyText>
                    <MyText>
                        <IntlMessage id={'aboutPage.task3'}/>
                    </MyText>
                    <MyText>
                        <IntlMessage id={'aboutPage.task4'}/>
                    </MyText>
                    <MyText>
                        <IntlMessage id={'aboutPage.task5'}/>
                    </MyText>
                    <MyText>
                        <IntlMessage id={'aboutPage.task6'}/>
                    </MyText>
                    <MyText>
                        <IntlMessage id={'aboutPage.task7'}/>
                    </MyText>
                    <MyText>
                        <IntlMessage id={'aboutPage.task8'}/>
                    </MyText>
                    <MyText>
                        <IntlMessage id={'aboutPage.task9'}/>
                    </MyText>
                    <MyText>
                        <IntlMessage id={'aboutPage.task10'}/>
                    </MyText>
                    <MyText>
                        <IntlMessage id={'aboutPage.task11'}/>
                    </MyText>
                    <HorizontalDivider/>
                    <MyText strong size={"large"}>
                        <IntlMessage id={'aboutPage.projectResults'}/>
                    </MyText>
                    <MyText>
                        <IntlMessage id={'aboutPage.result1'}/>
                    </MyText>
                    <MyText>
                        <IntlMessage id={'aboutPage.result2'}/>
                    </MyText>
                    <MyText>
                        <IntlMessage id={'aboutPage.result3'}/>
                    </MyText>
                    <MyText>
                        <IntlMessage id={'aboutPage.result4'}/>
                    </MyText>
                    <MyText>
                        <IntlMessage id={'aboutPage.result5'}/>
                    </MyText>
                </Fade>
                <HorizontalDivider/>
                <MyText strong size={"large"}>
                    <IntlMessage id={'aboutPage.researchTeam'}/>
                </MyText>
                <Flex style={{width: "100%", position: "relative"}} align={"center"} justify={"space-between"} gap={35} wrap={"wrap"}>
                    {data.map(user => <UserCard user={user} setOpen={setOpen} setTargetName={setTargetName} setModalTarget={setModalTarget}/>)}
                </Flex>
                {/*<Table columns={columns} dataSource={data} pagination={{ pageSize: 100 }} />*/}
                <HorizontalDivider/>
                <Link to={'/list-articles'}
                      style={{fontSize: "1rem", fontWeight: 700}}><IntlMessage
                    id={'listOfPublishedArticles'}/> <DoubleRightOutlined /></Link>
            </Flex>
        </Flex>
    );
};

const Person21 = () => {
    return (
        <Flex style={{ width: "100%", position: "relative" }} vertical gap={20}>
            <Flex style={{ width: "100%", position: "relative" }} gap={40}>
                <Fade triggerOnce={true} cascade damping={0.15}>
                    <Image src={img21} width={300} preview={false} style={{ borderRadius: 20 }} />
                </Fade>

                <Flex style={{ width: "100%", position: "relative" }} vertical>
                    <MyText strong size={"large"}>
                        Куспанов Ескендир Рустамович
                    </MyText>
                    <MyText style={{ color: clrs.whiterBlacker }}>
                        Бакалавр Систем Информационной Безопасности, Магистрант Технологий Искусственного Интеллекта
                    </MyText>
                    <br />
                    <HorizontalDivider />
                    <br />
                    <MyText strong size={"small"}>
                        Основное место работы, должность
                    </MyText>
                    <MyText>
                        «Prometeo Chain System KZ Ltd», инженер-программист
                    </MyText>
                </Flex>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Стаж по профилю</MyText>
                <MyText size={"small"}>
                    2 года 10 месяцев
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в проекте или программе, а также характер выполняемой работы</MyText>
                <MyText size={"small"} italic>
                    Блокчейн разработчик Ikarus Network
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Поддержка и обновление нодов Ikarus Network внутри Astana IT;
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Поддержка и улучшение обработки данных с IoT-датчиков.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Краткое обоснование участия</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Магистрант по специальности «Технологии искусственного интеллекта» по теме «Программная реализация логического метаязыка конечных автоматов».
                </MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Навыки: Python, MongoDB, Redis, FastAPI, Docker, JavaScript. Знания в области разработки распределённых систем, обработки данных и проектирования backend-инфраструктуры.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Научные проекты, в которых принимал участие:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    Участвует в проекте программно-целевого финансирования на 2023-2025 гг. ИРН BR21882258 «Разработка комплекса интеллектуальных информационно-коммуникационных систем для экологического мониторинга эмиссий в окружающую среду для принятия решения в концепте углеродной нейтральности». Роль – исполнитель.
                </MyText>
            </Flex>

            <Flex style={{ width: "100%", position: "relative" }} vertical>
                <MyText strong size={"small"}>Роль в достижении результатов проекта:</MyText>
                <MyText size={"small"} style={{ paddingLeft: 20 }}>
                    - Поддержка и улучшение обработки данных с IoT-датчиков.
                </MyText>
            </Flex>
        </Flex>
    );
}

export default AboutPage;